import cryptoJs from 'crypto-js';
import securekey from '../config';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 */
const SessionData = () => {

    const getEmployeeSession = () => {
        // Retrieve employee data from session storage
        const employeeData = sessionStorage.getItem('employeeEntryData');

        // Decrypt the stored employee data using AES decryption
        const bytesS = cryptoJs.AES.decrypt(employeeData || '', securekey);

        // Convert decrypted bytes to UTF-8 string
        const userString = bytesS.toString(cryptoJs.enc.Utf8);

        // Parse the decrypted string into a JSON object and return
        return userString ? JSON.parse(userString) : '';
    }

    const getUserSession = () => {
        // Retrieve user data from session storage
        const userData = sessionStorage.getItem('userdata');

        // Decrypt the stored user data using AES decryption
        const bytesS = cryptoJs.AES.decrypt(userData || '', securekey);

        // Convert decrypted bytes to UTF-8 string
        const userString = bytesS.toString(cryptoJs.enc.Utf8);

        // Parse the decrypted string into a JSON object and return
        return userString ? JSON.parse(userString).data.data : '';
    }

    return {
        getEmployeeSession,
        getUserSession
    }

}

export default SessionData
